export default "__VITE_ASSET__RphpdCyP__"